// extracted by mini-css-extract-plugin
export var invAccNote = "style-module--invAccNote--a2b4e";
export var myAccountNote = "style-module--myAccountNote--11a0a";
export var preview = "style-module--preview--75a16";
export var storeSwitchWarning = "style-module--storeSwitchWarning--3470d";
export var subsection = "style-module--subsection--e9976";